// 찜질방 보행 격자 2개: 어른용(놀이터 막힘)과 아기용(놀이터 열림, 울타리 문으로만). 프로토타입 3138–3154.
// 장애물 목록은 장면을 만들면서 모은다 (scene). three.js를 쓰지 않는 순수 TS.
import { createNavGrid, type NavGrid } from '../../engine/nav';
import { AREAS, CUBBY_RECT, JAREA, JDOORS, JNAV, PLAY, TUBS, inPlay, inTub } from './layout';

/** 사각형 장애물 [x0, x1, z0, z1]. seat: 앉는 자리(통나무·상), kidzone: 아기는 지나갈 수 있는 놀이터 기구. */
export interface JObstacle { rect: [number, number, number, number]; seat?: boolean; baby?: boolean; kidzone?: boolean }

export function buildJjimGrids(obj: readonly JObstacle[]): { adult: NavGrid; baby: NavGrid } {
  const adult = createNavGrid(JNAV), baby = createNavGrid(JNAV), { x0, z0, cs, nx, nz } = JNAV, cr = CUBBY_RECT;
  for (let j = 0; j < nz; j++) for (let i = 0; i < nx; i++) {
    const x = x0 + (i + 0.5) * cs, z = z0 + (j + 0.5) * cs, k = j * nx + i;
    let open = false;
    for (const a of AREAS) { const A = JAREA[a]; if (x > A.x0 + 0.35 && x < A.x1 - 0.35 && z > A.z0 + 0.35 && z < A.z1 - 0.35) open = true; }
    if (JDOORS.some((d) => Math.hypot(x - d.hallP.x, z - d.hallP.z) < 0.7 || Math.hypot(x - d.roomP.x, z - d.roomP.z) < 0.7)) open = true;
    let b = !open;
    for (const o of obj) { const r = o.rect; if (x > r[0] - 0.25 && x < r[1] + 0.25 && z > r[2] - 0.25 && z < r[3] + 0.25) b = true; }
    // 굴방: 칸 사이 벽 쪽은 막고 가운데만 연다
    if (x > cr[0] - 0.1 && x < cr[1] && z > cr[2] && z < cr[3]) { const W = (cr[3] - cr[2]) / 4, li = (z - cr[2]) % W; b = b || li < 0.85 || li > W - 0.85; }
    if (inTub(TUBS.hot, x, z, -0.1) && !inTub(TUBS.hot, x, z, 0.25)) b = b || false;
    const fence = (x > PLAY.x0 - 0.3 && x < PLAY.x1 + 0.3 && Math.abs(z - PLAY.z0) < 0.3) || (Math.abs(x - PLAY.x1) < 0.3 && z > PLAY.z0 && z < PLAY.z1);
    adult.cells[k] = b || inPlay(x, z) || fence ? 1 : 0;
    const fenceB = fence && Math.abs(x - PLAY.gate.x) > 0.55;
    const kid = inPlay(x, z) && ((Math.hypot(x - PLAY.tramp.x, z - PLAY.tramp.z) < PLAY.tramp.r + 0.3) || (x > PLAY.pit.x0 - 0.2 && x < PLAY.pit.x1 + 0.2 && z > PLAY.pit.z0 - 0.2 && z < PLAY.pit.z1 + 0.2));
    baby.cells[k] = (b && !(inPlay(x, z) && !obj.some((o) => o.kidzone && x > o.rect[0] - 0.25 && x < o.rect[1] + 0.25 && z > o.rect[2] - 0.25 && z < o.rect[3] + 0.25))) || fenceB ? 1 : 0;
    if (kid) baby.cells[k] = 0;
  }
  return { adult, baby };
}
